"use strict";

exports.__esModule = true;
exports.POST_ACTIONS = exports.POST_ACTION_REVERT_TO_DRAFT = exports.POST_ACTION_DUPLICATE = exports.POST_ACTION_DELETE = exports.POST_ACTION_REPORT = exports.POST_ACTION_TOGGLE_COMMENTS = exports.POST_ACTION_PIN = exports.POST_ACTION_SHARE = exports.POST_ACTION_EDIT = exports.POST_ACTION_SUBSCRIBE = void 0;
var POST_ACTION_SUBSCRIBE = 'subscribe';
exports.POST_ACTION_SUBSCRIBE = POST_ACTION_SUBSCRIBE;
var POST_ACTION_EDIT = 'edit';
exports.POST_ACTION_EDIT = POST_ACTION_EDIT;
var POST_ACTION_SHARE = 'share';
exports.POST_ACTION_SHARE = POST_ACTION_SHARE;
var POST_ACTION_PIN = 'pin';
exports.POST_ACTION_PIN = POST_ACTION_PIN;
var POST_ACTION_TOGGLE_COMMENTS = 'toggle-comments';
exports.POST_ACTION_TOGGLE_COMMENTS = POST_ACTION_TOGGLE_COMMENTS;
var POST_ACTION_REPORT = 'report';
exports.POST_ACTION_REPORT = POST_ACTION_REPORT;
var POST_ACTION_DELETE = 'delete';
exports.POST_ACTION_DELETE = POST_ACTION_DELETE;
var POST_ACTION_DUPLICATE = 'duplicate';
exports.POST_ACTION_DUPLICATE = POST_ACTION_DUPLICATE;
var POST_ACTION_REVERT_TO_DRAFT = 'revert-to-draft';
exports.POST_ACTION_REVERT_TO_DRAFT = POST_ACTION_REVERT_TO_DRAFT;
var POST_ACTIONS = [POST_ACTION_SUBSCRIBE, POST_ACTION_EDIT, POST_ACTION_SHARE, POST_ACTION_PIN, POST_ACTION_REVERT_TO_DRAFT, POST_ACTION_TOGGLE_COMMENTS, POST_ACTION_REPORT, POST_ACTION_DELETE];
exports.POST_ACTIONS = POST_ACTIONS;